var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 22,
    viewBox: "0 0 19 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6332 13.8668L16.6875 11.9212V9.34375C16.6853 7.56257 16.0227 5.84548 14.8278 4.52452C13.633 3.20355 11.9908 2.37255 10.2188 2.19219V0.71875H8.78125V2.19219C7.00922 2.37255 5.36702 3.20355 4.17217 4.52452C2.97733 5.84548 2.31473 7.56257 2.3125 9.34375V11.9212L0.366844 13.8668C0.232043 14.0016 0.156291 14.1844 0.15625 14.375V16.5312C0.15625 16.7219 0.231975 16.9047 0.366767 17.0395C0.501559 17.1743 0.684376 17.25 0.875 17.25H5.90625V17.9688C5.90625 18.9219 6.28488 19.836 6.95884 20.5099C7.63279 21.1839 8.54688 21.5625 9.5 21.5625C10.4531 21.5625 11.3672 21.1839 12.0412 20.5099C12.7151 19.836 13.0938 18.9219 13.0938 17.9688V17.25H18.125C18.3156 17.25 18.4984 17.1743 18.6332 17.0395C18.768 16.9047 18.8438 16.7219 18.8438 16.5312V14.375C18.8437 14.1844 18.768 14.0016 18.6332 13.8668ZM11.6562 17.9688C11.6562 18.5406 11.4291 19.0891 11.0247 19.4935C10.6203 19.8978 10.0719 20.125 9.5 20.125C8.92813 20.125 8.37968 19.8978 7.9753 19.4935C7.57093 19.0891 7.34375 18.5406 7.34375 17.9688V17.25H11.6562V17.9688Z",
    fill: "#3D3D3B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.a4806137dbe729eebe0b8a068d1c93df.svg";
export { ForwardRef as ReactComponent };